export const dateValueGetter = (value: string): Date | null => {
  const parsed = value ? new Date(value) : null;
  return parsed;
};
